import React, { Component } from "react";
import Header from "../Login/Header";
import Footer from "./Footer";
import {
  Collapse,
  CardBody,
  Card,
  CardHeader
} from 'reactstrap';
class Faq extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: -1,
      loginPop: false
    };
    this.toggle = this.toggle.bind(this);
  }
  componentDidMount() {

  }
  toggle = (e, event) => {
    e.preventDefault();
    this.setState({
      collapse: this.state.collapse === Number(event) ? -1 : Number(event),
      loginPop: false
    });
  }
  render() {

    const { collapse } = this.state;
    const faqArr = [
      {
        isGeneral: true,
        qus: 'What does BeWise offer?',
        ans: `
        <p>Parents, in their tireless effort to provide children the best education, fun, 
        skills and training, lean heavily either on personal networks or on web search engines.</p>
        <p>BeWise is a comprehensive search platform to the parent that helps you with all relevant
         information / available options and alternatives with filters to help you evaluate the 
         options resourcefully, there by remain wise in your decision making.&nbsp; You will 
         be able to discover, search, filter based on key needs and choose best suited for 
         you and your child across academic and non-academic learning.&nbsp; These includes - 
         <a href="https://www.bewise.in/bengaluru/schools/private-schools">Schools</a>, 
         <a href="https://www.bewise.in/bengaluru/pre-schools/kindergarten">Preschools</a>, 
         <a href="https://www.bewise.in/bengaluru/after-school-activity/sports">After School 
         Activities</a> like <a href="https://www.bewise.in/bengaluru/after-school-activity/music">
         Music</a>, Sports or extra curriculars, <a href="https://www.bewise.in/bengaluru/tuitions/mathematics">
         Tuitions</a>, <a href="https://www.bewise.in/bengaluru/kids-play-area/indoor">Play areas</a>
         , Counsellor support, short and long-term <a href="https://www.bewise.in/learning-camps/curated-learning-camps">
         Learning camps</a>, Birthday celebration options and latest in education for the young and 
         many more. Bewise aims to be your one stop solution for in helping you discover &amp; 
         manage the learning journey for your child and enable quality outcomes you seek.</p>
        `
      },
      {
        isGeneral: true,
        qus: `I am a parent of a toddler, how can BeWise be helpful for me?`,
        ans: `
        <p>BeWise helps you&nbsp;find, compare, follow an institution or individual to understand their 
        progress, begin potential exploration / interactions with institutions like pre - 
        schools / schools / afterschool&rsquo;s, play areas, explore 
        <a href="https://www.bewise.in/bengaluru/birthday-event/venues">birthday venues</a>, 
        explore online or offline learning options that is of interest to the child etc.</p>
        <p>All this at <a href="https://www.bewise.in/">BeWise</a> your one stop platform for 
        child&rsquo;s growth</p>
        `
      },
      {
        isGeneral: true,
        qus: `Is the access to BeWise free?`,
        ans: `
        <p>Yes, access to BeWise parent portal is free for the entire parent community.</p>
        `
      },
      {
        isGeneral: true,
        qus: `As a parent what benefits do I receive once I signup?`,
        ans: `
        <p>Your sign up is for free as a parent.</p>
        <p>You will be able to discover, search, compare and choose across 
        <strong>all learning options</strong> available for your child (Below 15 Y) very 
        easily based on your specific need in the search.&nbsp;</p>
        <p>For example &ndash; Distance / Fees / Online or offline / At your residence or 
        nearby / Syllabus / Facilities / Reviews / Rankings where available etc.&nbsp;</p>
        <p>Additionally, you will have easy access to 
        <a href="https://www.bewise.in/bengaluru/community-support/articles-blogs">
        insightful articles</a>, newsletters, to help you maximise value, signing up for 
        events of interest, free downloads or freebies, getting notified from the institutions 
        you follow and more.&nbsp; We will continue strive &amp; ensure you are updated with 
        quality information and aware of trends that keeps you ahead on the curve.&nbsp; 
        Only you will choose to share your contacts with any &amp; we will not be sharing 
        with any organization or individual and hence none will inundate you with phone 
        calls or spam your mailboxes.</p>
        `
      },
      {
        isGeneral: true,
        qus: `I can't get access to all the data on the institutions, what can I do?`,
        ans: `
        <p>Not able to access all information, not to worry.&nbsp; You might have just 
        missed the step of being registered at our platform.&nbsp; To get full access to 
        all details of every provider.&nbsp; @BeWise one must follow 4 simple steps of 
        registration.</p>
        <ol>
        <li><a href='https://www.bewise.in'>Signup</a> with your mail id, or sign up via Google/Gmail/Facebook</li>
        <li>Enter relevant and basic information.</li>
        <li>Confirm with a click on welcome mail sent @ your registered mail id.</li>
        <li>Log in now and you are ready for search and all the available information will be easily visible during your search.</li>
        </ol>
        `
      },
      {
        isGeneral: true,
        qus: `What should I do to Rate/ Review an institution from my experience?`,
        ans: `
        <p><strong>Who can see my reviews?&nbsp; Will my name and details be displayed 
        to all?</strong></p>
        <p>Only registered users can review / rate an institution.&nbsp; <a href='https://www.bewise.in'>Signup</a> to 
        share your experience &amp; support the entire community with a quality review 
        from your experience which is of absolute value to all parties.&nbsp; Will help 
        another parent make a wise decision for his / her child, besides is an 
        opportunity for organisations / individuals to improve further or stay 
        motivated &amp; serve you even better.&nbsp;&nbsp;&nbsp; Genuine reviews 
        enable every parent to evaluate value &amp; understand challenges in working 
        with an institution / individual.&nbsp;</p>
        <p>@ BeWise, your review on a scale of 1-5 gets averaged and is a good balance 
        amidst multiple experiences. However, your words used at the feedback / review 
        carry a much higher value / deeper insights / interpretations to everyone 
        reading.&nbsp; 3 Simple handrails to follow for a quality review are:</p>
        <ul>
        <li>Provide factual &amp; constructive feedback. Short and specific</li>
        <li>Good to feedback on overall experience &ndash; not just one specific point.</li>
        <li>Do review / proofread - once before submitting it.</li>
        </ul>
        <p><strong>Can I edit my review?</strong></p>
        <p>You can edit your review for the next 30 days in case you change your 
        opinion or prefer to rephrase the words. Your rating and comments will 
        immediately show up on the portal, however, will remain anonymous as our 
        objective is not bring out names or grades of your children.</p>
        <p>Thank you for the time taken to review.</p>
        `
      },
      {
        isGeneral: true,
        qus: `What is compare option? Can I compare any 2 institutions? How to use this?`,
        ans: `
        <p>Yes &ndash; a parent once registered @ BeWise can leverage this compare option 
        during any search.&nbsp; This tool helps you bring all your choices together in one 
        page, so that your decision making / discussions with relevant folks are supported 
        with quality data.</p>
        <p>Once signed into BeWise portal, below steps enable you maximise:</p>
        <ul class='ul-tick'>
        <li>At every home page of an institution or individual @ BeWise, you will find 
        the compare button on top of the page.</li>
        <li>When you are on the page, and like an institution or individual, click on 
        this compare button. In doing so, you add this page to your compare list.</li>
        <li>Repeat process for up to a max of top 3 institutions you like within each 
        of the 8 categories we have listed them under.</li>
        <li>When ready to review list &ndash; click on your profile icon at top of any 
        page. Scroll down to choose the compare and click on the same.</li>
        <li>You will be moved to a page where all categories are listed with the number 
        of compare options you chose overtime. Choose and click on category you want to 
        activate compare currently.</li>
        <li>All added options will show up on this page that narrates your choices &amp; 
        compares parameters that will help you see differences &amp; similarities. 
        Helps you prioritize and enables you choose best suited.</li>
        <li>You can increase count of comparisons by following steps of deleting an 
        eliminated option &amp; continue adding similar options - as you work through 
        decisions when in the compare option.</li>
        </ul>
        `
      },
      {
        isGeneral: true,
        qus: `How do I find a school located in my area, what can I do?`,
        ans: `
        <p>Yes, this is quite easy with the Sharpen Your Search Option 
        available on the portal.</p>
        <ul class='ul-tick'>
        <li>Choose sharpen your search option and in filters &ndash; choose location 
        and type name of the locality you want to look up for a specific need.</li>
        <li>Revise distance pin &amp; move it to the distance you will be comfortable 
        with. Example when you choose MG road, how many Kilometres distance away 
        from MG road you are willing to consider as your area.</li>
        <li>The list automatically drops to your chosen distances &amp; ta da &ndash; 
        you have list of institutions as per your filter. schools or any other options in learning.</li>
        <li>We would encourage you to use all the filters that help you get sharper 
        in your search and not just location alone.</li>
        </ul>
        <p>Note: online learning does not have certain filters like distance applicable.</p>
        `
      },
      {
        isGeneral: true,
        qus: `Can I subscribe to the articles update from BeWise?`,
        ans: `
        <p><u>OfCourse, its quite easy! </u></p>
        <p>Yes, this can be done.&nbsp;</p>
        <p>Please scroll to the bottom of any page and add your mail id to the subscription 
        list and you will start receiving newsletters as and when published.</p>
        <p>However, if you are following any specific author, you will automatically 
        receive updates once there is a new article from that author has been published 
        at the BeWise portal.</p>
        `
      },
      {
        isGeneral: true,
        qus: `Can I write an article for BeWise? One that helps the community of parents & will it be 
        published @ BeWise for public read.`,
        ans: `
        <p>Yes &amp; we welcome your contributions to serve the parent community whole 
        heartedly.&nbsp; We will publish the same once we have aligned with you on the 
        specific details and feel free to reach out to us @ <a href="mailto:Contact@bewise.in">
        Contact@bewise.in</a>. &nbsp;Our marketing team will stay in touch with you.&nbsp; 
        We look forward to interactions / feedback from you.</p>
        `
      },
      {
        isGeneral: true,
        qus: `What does a follow button do on any page? What does a like button do?`,
        ans: `
        <p>When you click here, you will receive intimations every time there is any current 
        update made by the institution / individual to their home page, new announcements, 
        issuing of applications etc.</p>
        <p>Its good when you follow institutions / individuals as you can stay connected 
        to whatever the recent / current events so that you continue to remain updated.&nbsp; 
        Leveraging this option is also good for your child&rsquo;s current school or 
        other services provider as it keeps you abreast on their public announcements or 
        any latest developments which does not reach you through the normal intimation process.</p>
        <p>Like button that is available is for the institution or other parents to know 
        and receive the feedback that you liked what you saw, although you may not be using 
        their services.</p>
        <p>In either case &ndash; your contact details will not be shared with the 
        institution as per our privacy policy and you will not receive other non-required 
        mails to SPAM your inbox.</p>
        `
      },
      {
        isGeneral: true,
        qus: `Will you share all or any of our data to suppliers when we browse your portal?`,
        ans: `
        <p>No.&nbsp; We do not share any data about any parent to the providers.&nbsp; 
        Please refer our <a href='https://www.bewise.in/privacypolicy'>Privacy policy</a> </p>
        <p>You will decide if you want to share your contact details to the providers 
        when you make that call / write the mail to ensure connections and usage of services</p>
        `
      },
      {
        isGeneral: true,
        qus: `Do you provide guarantee for third-party sites / institutions provided at your portal?`,
        ans: `
        <p>No.&nbsp; We do not provide any guarantee to any of the third parties in the portal 
        or for anything that we do not own. We are making our best attempt to reduce the pain 
        points that you will likely have when you are trying to reach the providers on your 
        own.&nbsp; Please read our <a href='https://www.bewise.in/termsconditions'>Terms &amp; Conditions </a> and 
        <a href='https://www.bewise.in/privacypolicy'>Privacy policy</a> 
        to ensure our commitments.</p>
        <p>Having said that, we surely confirm the quality of information provided with our 
        selected <a href="https://partner.bewise.in/individual">partners</a> / curated events / 
        BeWise endorsed partners as indicated on the pages.&nbsp; Our teams are making continuous 
        efforts to increase the reach of such partners and we will continue to improve 
        upon the same as our promise to serve you better.</p>
        `
      },
      {
        isGeneral: true,
        qus: `Parents from which cities can gain the benefits from BeWise?`,
        ans: `
        <p><a href="https://www.bewise.in/">BeWise</a> is successfully launched in 
        Bangalore &amp; Chennai.</p>
        <p>Other cities in the pipeline for next 4 months include Hyderabad, Madurai, Coimbatore.</p>
        `
      },
      {
        isPartner: true,
        qus: 'What does BeWise offer for me to be a Partner / Tutor / Coach?',
        ans: `
        <p>You are already aware that the education industry in India &amp; Globally has 
        evolved and embraced plenty of changes over the last decade driven by technology 
        (Digital. Mobile, Web, AI etc) &amp; increasing customer expectations, besides 
        learnings from the pandemic.&nbsp; You will agree that this is now changing the 
        approach and options to leverage in reaching, your customer and managing growth.</p>
        <p>BeWise helps in all your objectives and enables brand presence effectively &amp; 
        efficiently. We help you reach your target audience all through the year and help 
        your organisation take a much larger role in the education industry and the parent 
        community.&nbsp; You will gain substantial benefits &amp; support to growing your 
        brand &amp; business.&nbsp; More details for an 
        <a href="https://partner.bewise.in/institution">Institution Partners</a> &amp; 
        for <a href="https://partner.bewise.in/individual">Individual </a>contributors 
        in the ecosystem</p>
        <p>Listed are a few benefits to help you thinking.&nbsp;</p>
        <ul class='ul-tick'>
        <li>Brand visibility &amp; Brand build with target audience 365 days of every year. 
        The journey for your brand begins even before a parent is thinking about any option, 
        &amp; not just when looking for your specific services.</li>
        <li>Data driven Insights to help you understand trends in your specific service segment 
        even better and make wise decisions * 365. Business receive access to analytics for
         this objective when partnered with us.</li>
        <li>Insights from detailed reviews / ratings / comparisons help you work with 
        feedback and improvements so that you can build the brand you wanted to in the first place.</li>
        <li>Effective communication on the BeWise portal helps quickly reach information to 
        prospects &amp; customers following you. Prospects can reach you on portal via 
        messages before agreeing to exchange contacts.</li>
        <li>Leverage value from the new age partnerships we are building so that you 
        can accelerate your business growth &amp; capabilities.</li>
        <li>BeWise helps you become a thought leader and a brand with the target audience 
        &amp; industry, for businesses who are keen to build brands longer term through 
        quality engagement &amp; content.</li>
        <li>BeWise will help you in benchmarking efforts to organisations / individuals 
        with the same service offerings 365 days of the year. This will help you understand, 
        learn from &amp; enable a position of strength for yourself.</li>
        <li>We are launching soon a teachers / coaches recruitment extension to our 
        portal. This is to help every institution in both short term and long-term 
        talent needs, efficiently.&nbsp;</li>
        </ul>
        <p>If you wish to speak with our business development team, please write to us 
        <a href="mailto:contact@bewise.in">contact@bewise.in</a> &amp; Team 
        <a href="https://www.bewise.in/">BeWise</a> we will reach out to you for clarifications.</p>
        `
      },
      {
        isPartner: true,
        qus: `What benefits do I receive when advertising in your portal?`,
        ans: `
        <p>Scope for advertising @ BeWise portal is limited.</p>
        <p>We have a few banner/s space &amp; tickers which we encourage organisations 
        to use.&nbsp; Benefits when an institution uses these banners are as below 
        (Banners and tickers are at both ends of the portal &ndash; parents view &amp; our partners view)</p>
        <ol>
        <li>Grow brand visibility, brand recall &amp; brand recognition</li>
        <li>Increase traffic to landing page @ BeWise or to your own web page.</li>
        <li>Showcase any event, either pre or post event based on your objectives. 
        (Example an interschool competition or a victory for the institution in an event)</li>
        <li>Sharing of specific information to target audience with parents or other 
        institutions (Moving campus / recruitment or enrolment drive etc)</li>
        </ol>
        `
      },
      {
        isPartner: true,
        qus: `Who will be able to see the parent reviews @ BeWise?  
        Can we respond to the reviews received directly?  
        Will you be helping us in getting quality reviews?`,
        ans: `
        <p>Every registered visitor to the BeWise portal will get visibility to 
        the reviews and comments for any individual or institution.</p>
        <p>Yes, one can respond to those reviews to the reviewer directly, 
        so that you can maximise in brand build or have an edit in ratings or 
        reviews. Conversion from an average review to a good review can happen 
        with your efforts in working with the feedback &amp; interactions with reviewers.</p>
        <p>BeWise has the right to delete only inappropriate comments or poor 
        language to help a quality environment within the community, as part 
        of our terms and conditions.</p>
        <p>We have planned marketing efforts to continuously improve the 
        quantity of reviews from parents and this is a time-consuming process.&nbsp;
        However, we are willing to help accelerate this for every partner by cocreating 
        value.&nbsp; This would include requests for independent feedback via BeWise 
        from current customers / parents / community and share summarised feedback 
        to help you focus on potential improvement opportunities ahead.&nbsp; 
        Increased reviews would also impact the algorithms which drive higher brand visibility.</p>
        `
      },
      {
        isPartner: true,
        qus: `Who will be uploading correct data in your team?  How fast can this be done?  `,
        ans: `
        <p>The registered partner will be uploading all the requested data in the account 
        page you can access after registration.&nbsp; The process is quite simple, and our 
        business development team can guide you if required.&nbsp; The first time go live 
        for a new sign up is 24 hours, however for the next time onwards &ndash; the upload 
        to page is immediate.</p>
        <p>The entire updating of BeWise portal with quality information can take you 
        anywhere between 15 minutes to an hour depending on quality of time you spend on the same.</p>
        `
      },
      {
        isPartner: true,
        qus: `How often can I update content on our pages?`,
        ans: `
        <p>There is no restrictions to the number of times one can update content on their page. 
        We encourage everyone to keep this frequent and ensure quality updates so that 
        every parent understands your brand and values even better.</p>
        `
      },
      {
        isPartner: true,
        qus: `Can I get detailed data on everyone browsing for my services in BeWise portal? `,
        ans: `
        <p>Our privacy policy does not allow us to share detailed data at an 
        individual level with any organisation.&nbsp; The partner account page will 
        always carry the information on number of visitors / trends / those who 
        have saved your profile and many similar.&nbsp;</p>
        <p>Once the parent writes to your institution directly or call the number 
        provided for (Possible when you are listed as a BeWise partner), their mail 
        id or phone number enables you to be in touch with them directly to resolve 
        or support the query.</p>
        `
      },
      {
        isPartner: true,
        qus: `Can I cancel my subscription midway of the year?  What is the process of cancellation?`,
        ans: `
        <p>Yes, a partner can cancel the subscription anytime they choose to as per our 
        <a href='https://partner.bewise.in/termsconditions'>Terms and conditions</a> via the account page and reimbursements 
        will be sent across as per the said policy for the remaining period of contract.</p>
        `
      },
      {
        isPartner: true,
        qus: `Is my subscription auto renewed?`,
        ans: `
        <p>No, the subscription is not auto renewed, and you will receive an intimation 
        to renew the same and maintain continuity.  Auto renewal option is currently under review.</p>
        `
      },
      {
        isPartner: true,
        qus: `Can I write or send articles about our institution that can be published @ BeWise?`,
        ans: `
        <p>Yes. Only selected articles, exclusively written for BeWise communities of institutions 
        and parents agreed in advance around preselect topics shall be published at the 
        BeWise portal with support from our marketing teams.&nbsp; These 
        <a href="https://www.bewise.in/bengaluru/community-support/articles-blogs">articles</a> 
        must be on topics that is focussed on value and insights to the parents and parent 
        community.&nbsp; We will also help leaders / authors with a larger reach at other 
        select electronic publications, we work and help build thought leadership and the 
        brand for your institution/ leaders.</p>
        `
      },
      {
        isPartner: true,
        qus: `What data & Insights will I get for my subscription?`,
        ans: `
        <p>Please click on links provide to understand specific benefits, data &amp; 
        insights you will receive as a partner at the BeWise portal&nbsp;</p>
        <p>Click here if <a href="https://partner.bewise.in/institution">Institution 
        Partner</a> &amp; If you are <a href="https://partner.bewise.in/individual">Individual 
        Partner</a></p>
        `
      },
    ];
    return (
      <React.Fragment>
        <div className="container-fluid full-width nopadding">
          <div className="row nomargin">
            <div className="col-sm-12 header-color">
              <Header />
            </div>
          </div>
          <section class="breadcrumb-area">
            <div class="container">
              <div class="row">
                <div class="col-lg-12 col-sm-12 col-xs-12">
                  <div class="left-side pull-left headng">
                    <h1>FAQ's </h1>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div class="about-page">

            <section className="py-4">
              <div className="container">
                <div className="row no-margin">
                  <div className="row">
                    <div className="col-sm-12">
                      <div class="about-page">
                        <section class="custom-sec">
                          <div className="container">

                            <div className="about-wrap">
                              <div className="container">
                                <h4>For Individual/ Institution</h4>
                                <Card className='panel-group custom-card' style={{ marginBottom: '1rem' }}>
                                  {faqArr.map((item, index) => {
                                    if (item.isPartner)
                                      return (
                                        <React.Fragment>
                                          <CardHeader onClick={(e) => this.toggle(e, index)} data-event={index} className='custom-card-heading'>
                                            <b>{item.qus} </b>
                                            {collapse !== index ? (
                                              <span className='pull-right'>
                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                              </span>
                                            ) : (
                                              <span className='pull-right'>
                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                              </span>
                                            )}
                                          </CardHeader>
                                          <Collapse isOpen={collapse === index}>
                                            <CardBody className='panel-body'>
                                              <p dangerouslySetInnerHTML={{ __html: item.ans }}></p>
                                            </CardBody>
                                          </Collapse>

                                        </React.Fragment>
                                      )
                                  })}
                                </Card>
                                <h4>General</h4>
                                <Card className='panel-group custom-card' style={{ marginBottom: '1rem' }}>
                                  {faqArr.map((item, index) => {
                                    if (item.isGeneral)
                                      return (
                                        <React.Fragment>
                                          <CardHeader onClick={(e) => this.toggle(e, index)} data-event={index} className='custom-card-heading'>
                                            <b>{item.qus} </b>
                                            {collapse !== index ? (
                                              <span className='pull-right'>
                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                              </span>
                                            ) : (
                                              <span className='pull-right'>
                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                              </span>
                                            )}
                                          </CardHeader>
                                          <Collapse isOpen={collapse === index}>
                                            <CardBody className='panel-body'>
                                              <p dangerouslySetInnerHTML={{ __html: item.ans }}></p>
                                            </CardBody>
                                          </Collapse>

                                        </React.Fragment>
                                      )
                                  })}
                                </Card>
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <Footer />

      </React.Fragment>
    );
  }
}

export default Faq;



// WEBPACK FOOTER //
// ./src/components/Copyrights/faq.jsx